import * as types from './types';
import { InvoiceProjectService } from '../../services/invoice-project.service';
import { HttpLib, CancelHttpLibToken } from '../../../../services/http/http-lib';
import { REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import router from '../../../../router';
import { setMainNavInactive } from '../../../../store/app/mutations';
import { createHttpGetOptions, HttpClient } from '../../../../services/http/http-client';
import { MODIFICATION_URL } from '../../../../services/common-urls';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';

let invoiceDetailsSource;

const NavTabModule = getNavTabModule(types.InvoiceProjectDetails, 'invoiceProjectDetails');
const invoice_project_idr = () => router.currentRoute.params.invoice_project_id;
export const invoiceProjectActions = {
  ...NavTabModule.implementActions(
    'invoice_project_id',
    'identities/invoice_project_id/tab',
    'identities',
    () => router,
    'settings',
    (value, key) => {
      return {
        title: value?.invoice_project?.invoice_project_name ?? key,
        full_title: value?.invoice_project?.invoice_project_name ?? key
      }
    }
  ),
  // Show Sidewindow
  async [types.InvoiceProjectDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, invoiceProject, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "invoice_project_id";
    const itemName = "invoiceProject";
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "invoiceProjectDetails";
    const DetailsAction = types.InvoiceProjectDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req
    const invoiceProjectDetails = await InvoiceProjectService.findInvoiceProjectDetails({
      invoice_project_id: primaryKeyValue
    });

    // console.log('invoiceProjectDetails:mdsir', invoiceProjectDetails.data);

    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, invoiceProject) => {
        return {
          ...invoiceProject,
          ...invoiceProjectDetails.data,
          loading: false,
        };
      });
  },
  async [types.InvoiceProjectDetails.UPDATE.MULTIPLE]({ dispatch, getters }, payload) {
    const { invoice_project_id, ...rest } = payload;
    const ipID = invoice_project_id ? invoice_project_id : invoice_project_idr();

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(ipID, ipDetailsObj => {
      return {
        ...ipDetailsObj,
        ...rest
      };
    });
  },
  async [types.Invoice_Projects.FETCH.ALL]({ commit }, payload) {
    const invoiceProjects = await InvoiceProjectService.findInvoiceProjects(payload);
    console.log("invoiceProjects.data", invoiceProjects.data);
    if (invoiceProjects.data && invoiceProjects.data.invoice_projects && invoiceProjects.data.invoice_projects.length > -1) {
      commit(types.Invoice_Projects.SET.ALL, invoiceProjects.data.invoice_projects);
      return Promise.resolve(invoiceProjects.data.invoice_projects);
    } else {
      return Promise.reject(invoiceProjects.data.status);
    }

  },
  async [types.Invoice_Project_Details.SET.SINGLE]({ commit }, payload) {
    const { flag, invoiceProject } = payload;

    setMainNavInactive(commit, flag);

    if (flag) {
      const { invoice_project_id } = invoiceProject;

      invoiceDetailsSource = CancelHttpLibToken(invoiceDetailsSource);
      commit(types.Invoice_Project_Details.SET.SINGLE, {
        loading: true,
      });

      const invoiceProjectDetails = await InvoiceProjectService.findInvoiceProjectDetails({
        invoice_project_id
      }, createHttpGetOptions({
        cancelToken: invoiceDetailsSource.token
      }));

      console.log(invoiceProjectDetails.data);

      commit(types.Invoice_Project_Details.SET.SINGLE, {
        ...invoiceProjectDetails.data,
        loading: false,
      });
    }
  },
  async [types.SELECT_INVOICE_PROJECT_AUTO]({ commit }, payload) {
    router.push({
      name: 'identities'
    });
  },
  async [types.Invoice_Project_Details.UPDATE.SINGLE]({ commit, getters }, payload) {
    const { name, value } = payload;
    console.log(payload);

    const kVal = getters.invoiceProjectDetails?.invoice_project?.invoice_project_id;
    const table = 'invoice_projects';


    commit(types.Invoice_Project_Details.UPDATE.SINGLE, { name, value });

    console.log({
      kVal,
      name,
      value,
      table,
    });

    const updatedInvoiceProject = await HttpClient.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table,
    );
    console.log("Log: updatedInvoiceProject", updatedInvoiceProject);
  },
  async [types.InvoiceProjectDetails.UPDATE.SINGLE]({ dispatch, getters, commit }, payload) {
    const { name, value } = payload;

    const selectedInvoiceProject = getters.invoiceProjectDetails[invoice_project_idr()];
    const kVal = selectedInvoiceProject?.invoice_project?.invoice_project_id;
    const table = 'invoice_projects';
    let keyName=name == 'share_invitation_email_data'?'text_elements':name;
    dispatch(types.InvoiceProjectDetails.UPDATE.MULTIPLE, {
      invoice_project: { ...selectedInvoiceProject.invoice_project, [keyName]: value }
    });
  
    if (["invoice_project_name"].includes(keyName)) {
      const updatedItems = getters.invoiceProjects.map(row => {
        return row.invoice_project_id == kVal ? { ...row, [keyName]: value } : row;
      });
      commit(types.Invoice_Projects.SET.ALL, updatedItems);
    }

    if (['header', 'footer', 'header_cost', 'footer_cost', 'header_royalty', 'footer_royalty'].includes(name)) {
      const modifiedInvoiceProject = await HttpClient.post(MODIFICATION_URL, {
        modify_type: 'record',
        table,
        kVal,
        [name]: value,
      });
    }
    else if (name == 'text_elements') {
      const resData = await InvoiceProjectService.updateTextElement({
        invoice_project_id: kVal,
        text_elements: value
      });
    }
    else if (name == 'share_invitation_email_data') {
      const share_invitation_email_data = value.share_invitation_email_data;
      const resData = await InvoiceProjectService.updateInvitationEmail({
        invoice_project_id: kVal,
        share_invitation_email_data: share_invitation_email_data
      });
    }
    else {
      const updatedInvoiceProject = await HttpClient.modifyJSON(
        undefined,
        kVal,
        name,
        value,
        table,
      );
    }
  },
  async [types.Invoice_Projects.SET.ALL]({ commit }, payload) {
    commit(types.Invoice_Projects.SET.ALL, payload);
  },
  async [types.Invoice_Projects.DELETE.SINGLE]({ commit, getters }, invoiceProject) {
    // commit(types.Invoice_Projects.SET.ALL, payload);
    commit(types.Invoice_Projects.SET.ALL, getters.invoiceProjects.filter(e => {
      if (e.invoice_project_id == invoiceProject.invoice_project_id) {
        return false;
      } else {
        return true;
      }
    }));

    // Empty Response
    await InvoiceProjectService.deleteInvoiceProject(invoiceProject);
  },
  async [types.MODIFY_INVOICE_PROJECT]({ commit, getters }, payload) {
    const { name, value } = payload;

    console.log(payload);
    const kVal = getters.invoiceProjectDetails?.invoice_project?.invoice_project_id;

    commit(types.Invoice_Project_Details.UPDATE.SINGLE, { name, value });

    const modifiedInvoiceProject = await HttpClient.post(MODIFICATION_URL, {
      modify_type: 'record',
      table: 'invoice_projects',
      kVal: kVal,
      [name]: value,
    });

  },
  async [types.UPDATE_B2B_TEXT_ELEMENTS]({ commit, getters }, payload) {
    console.log('payload1', payload)
    const { invoice_project_id,
      text_elements } = payload
    commit(types.SET_B2B_TEXT_ELEMENTS, { ...text_elements });
    const resData = await InvoiceProjectService.updateTextElement({
      invoice_project_id,
      text_elements
    });
  },
}